import template from './main.html';

/** @type {import('angular').IDirective} */
const directive = {
	template,
	replace: false,
	restrict: 'A',
};

export default () => directive;
